export default [
  {
    path: '/quest-hidden',
    component: () => import('./views/Index'),
    name: 'quest-hidden',
    redirect: { name: 'quest-hidden-list' },
    children: [
      {
        path: '',
        name: 'quest-hidden-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
      {
        path: 'detail/:hidden_id',
        name: 'quest-hidden-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
